import Slider from 'react-slick';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

import Container from '../common/Container';
import CloudinaryImage from '../common/CloudinaryImage';

import './writetestimonial.css';

export default function WriteTestimonial({ Testimonials, lightBg }) {
  const settings = {
    centerMode: true,
    centerPadding: '60px',
    slidesToShow: 1,
    arrows: false,
    dots: true,
    autoplay: false,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          centerMode: false,
          centerPadding: '40px',
          slidesToShow: 1,
          adaptiveHeight: true,
        },
      },
    ],
  };
  return (
    <Container className={lightBg ? 'text-[#00102B]' : 'text-[#fff]'}>
      <div
        className={`text-center ${Testimonials?.title && 'xl:mb-[34px] md:mb-[30px] mb-[20px]'} `}
      >
        {Testimonials?.title && (
          <h2 className="xl:text-[55px] font-[800] md:text-[32px] text-[25px] leading-tight mb-3">
            {Testimonials?.title}
          </h2>
        )}
        {Testimonials?.description && (
          <p className="md:text-[20px] text-[16px] font-[400] leading-tight max-w-[1200px] mx-auto">
            {Testimonials?.description}
          </p>
        )}
        {Testimonials?.descriptionEditor && (
          <ReactMarkdown
            rehypePlugins={[rehypeRaw]}
            className={`md:text-[20px] text-[14px] font-[400] leading-tight max-w-[1200px] mx-auto`}
            source={Testimonials?.descriptionEditor}
          >
            {Testimonials?.descriptionEditor}
          </ReactMarkdown>
        )}
      </div>
      <Slider {...settings} className="text-[#fff] writetestimonial">
        {Testimonials?.testimonials?.map(data => (
          <div key={data?.id}>
            <div className="border border-[3px] border-[transparent] bg-[conic-gradient(from_180deg_at_50%_50%,_#D676FF_0deg,_#FFA030_120.63deg,_#8256FF_268.23deg,_#478EFF_360deg)] bg-clip-border rounded-[40px]">
              <div className="grid grid-cols-12 md:gap-10 gap-4 xl:py-[60px] lg:py-[40px] md:py-[30px] py-[20px] md:px-[20px] px-[20px] rounded-[40px] bg-[linear-gradient(260.66deg,_#141B27_79.26%,_#000ED5_111.48%),linear-gradient(110.72deg,_rgba(19,26,37,0.2)_80.68%,_rgba(0,80,213,0.2)_104.38%)]">
                <div className="md:col-span-4 col-span-12 text-center">
                  {data?.image?.data?.attributes?.url && (
                    <CloudinaryImage
                      backendImgUrl={data?.image?.data?.attributes?.url}
                      alt={data?.image?.data?.attributes?.alternativeText}
                      type="isTablet"
                      className={
                        'h-[100px] w-[100px] object-cover rounded-[100%] mx-auto'
                      }
                    />
                  )}
                  <p className="xl:text-[28px] text-[14px] font-[600]">
                    {data?.name}
                  </p>
                  <p className="xl:text-[18px] md:text-[14px] text-[12px] font-[400]">
                    {data?.designation}
                  </p>
                </div>
                <div className="md:col-span-8 col-span-12">
                  <CloudinaryImage
                    backendImgUrl={`https://res.cloudinary.com/dthpnue1d/image/upload/v1734543396/Vector_left_1_d3e26e4989.webp`}
                    alt={'Vector_left_1_d3e26e4989'}
                    type="icon"
                    className={'w-[50px] h-[50px] quart ml-[0px]'}
                  />
                  <p className="xl:text-[18px] md:text-[16px] text-[14px] font-[400] lg:px-8 md:pr-3 pr-0 lg:text-left text-center">
                    {data?.rich_text}
                  </p>
                  <CloudinaryImage
                    backendImgUrl={`https://res.cloudinary.com/dthpnue1d/image/upload/v1734543396/Vector_right_1_1486d7a2ed.webp`}
                    alt={'Vector_left_1_d3e26e4989'}
                    type="icon"
                    className={'w-[50px] h-[50px] quart mr-[0px]'}
                  />
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </Container>
  );
}
